var render = function render(){var _vm=this,_c=_vm._self._c;return (true)?_c('div',{staticClass:"text-center"},[_c('BlockUI',[_c('div',{staticClass:"loader"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }